module.exports = __webpack_public_path__ + "img/mini-021.88030369.jpg";